import { render, staticRenderFns } from "./registerStepOnboarding.vue?vue&type=template&id=09af4ad2&scoped=true&"
import script from "./registerStepOnboarding.vue?vue&type=script&lang=js&"
export * from "./registerStepOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./registerStepOnboarding.vue?vue&type=style&index=0&id=09af4ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09af4ad2",
  null
  
)

export default component.exports